import { useEffect, useState } from 'react';
import Link from 'next/link';
import ContentLoader from 'react-content-loader';
import { humanizeMonetaryValue } from '../../../util';

const RecentJobs = ({ number = 3 }) => {
  const [recentJobs, setRecentJobs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchRecent() {
      setIsLoading(true);
      const url = `/api/jobs/recent-jobs/recent-job-postings-by-lat-lng-header`;
      const response = await fetch(url);
      const data = await response.json();
      setRecentJobs(data.body.results.slice(0, number));
      setIsLoading(false);
    }

    fetchRecent();
  }, [number]);

  const RecentJobsLoader = ({ count }) => {
    return Array(count)
      .fill()
      .map((undefined, key) => {
        return (
          <div key={key} className={`col-sm-${12 / count} mb-3`}>
            <ContentLoader viewBox="0 0 400 150">
              <rect x="0" y="0" width="400" height="150" ry="10" rx="10" />
            </ContentLoader>
          </div>
        );
      });
  };

  return (
    <div className="row">
      {isLoading && <RecentJobsLoader count={number} />}
      {recentJobs.map((job, key) => {
        return (
          <div className={`col-sm-${12 / number} mb-3`} key={key}>
            <Link href={job.url} passHref>
              <a className="cta-card" href={job.url}>
                <span className="title">{job.title}</span>
                <span className="company">{job.company}</span>
                <span className="location">
                  <i className="fa-solid fa-location-dot"></i>
                  {job.location}
                </span>
                <Compensation job={job} />
              </a>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

const Compensation = ({ job }) => {
  if (typeof job.baseSalary !== 'object') {
    return <></>;
  }

  const { minValue, maxValue, currency, unitText } = job.baseSalary;

  if (!(minValue && maxValue && currency && unitText)) {
    return <></>;
  }

  return (
    <span className="salary">
      {unitText === 'YEAR' ? 'Salary Range' : 'Compensation'}:{' '}
      <span className="salary-range-bottom">{humanizeMonetaryValue(currency, minValue, 0)}</span>{' '}
      &ndash;{' '}
      <span className="salary-range-top">
        {humanizeMonetaryValue(currency, maxValue, 0)}
        <UnitText text={unitText} />
      </span>
    </span>
  );
};

const UnitText = ({ text }) => {
  let formatted = '';

  if (['MONTH', 'WEEK', 'DAY', 'HOUR', 'CONTRACT'].includes(text)) {
    formatted = ` per ${text.toLowerCase()}`;
  }

  return <>{formatted}</>;
};

module.exports = RecentJobs;
